/*
 * Mapping of common + extra languages from
 * Highlight.js to Prism.js
 *
 * IMPORTANT:
 * This is the basis of languages upon which
 * Highlight.js will try to guess, and also if
 * successful, talk to Prism.js to actually do the
 * highlighting. i.e. This is the list of languages
 * supported for syntax highlighting in editors.
 *
 * XXX(thx):
 * Make sure for whatever languages we are aiming to highlight,
 * we import prismjs language definitions in `loadPrismLangs`.
 *
 * References:
 * https://highlightjs.org/download/
 * http://prismjs.com/download.html
 */

// highlight.js -> prism.js
const commonLangs = {
  apache: "apacheconf",
  bash: "bash",
  c: "c",        // Not actual lang name for hljs, but Prism requires it..
  cs: "csharp",
  cpp: "cpp",
  css: "css",
  coffeescript: "coffeescript",
  diff: "diff",
  xml: "markup",
  http: "http",
  ini: "ini",
  json: "json",
  java: "java",
  javascript: "javascript",
  makefile: "makefile",
  markdown: "markdown",
  nginx: "nginx",
  objectivec: "objectivec",
  php: "php",
  perl: "perl",
  python: "python",
  ruby: "ruby",
  sql: "sql",
  shell: "bash",
};

// const extraLangs = {
//   r: "r",
//   vim: "vim",
//   go: "go",
//   tex: "latex",
//   swift: "swift",
//   scala: "scala",
//   haskell: "haskell",
//   lua: "lua",
//   matlab: "matlab",
//   arduino: "arduino",
//   groovy: "groovy",
//   puppet: "puppet",
//   rust: "rust",
//   powershell: "powershell",
//   erlang: "erlang",
//   typescript: "typescript",
//   ocaml: "ocaml",
//   d: "d",
//   dart: "dart",
//   julia: "julia",
//   fsharp: "fsharp",
//   elixir: "elixir",
// };

const hljsToPrismLangMap = Object.assign({},
  commonLangs,
  // NOTE(tyu): Common langs only for now b/c we are now
  // using highlight.js cdn which only includes common langs,
  // and also want to watch the bundle size.
  // extraLangs
);


export default hljsToPrismLangMap;



// WEBPACK FOOTER //
// ./src/shared/constants/hljsToPrismLangMap.js